module.exports = __webpack_public_path__ + "media/white_flare.aba4f200.webm";